import React from 'react';

import TerminalWindow from '../subsections/TerminalWindow';

import './Introduce.css';

function Introduce() {
  return (
    <div className="introduce">
      <TerminalWindow />
    </div>
  );
}

export default Introduce;
